"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonyTradeHub = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
class ColonyTradeHub extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.COLONY_TRADE_HUB,
            tags: [Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'P46',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.energy(1));
                    b.titanium(2);
                    b.preludeBox('effect', (ce) => {
                        ce.effect('When any colony is placed, gain 2 M€.', (eb) => {
                            eb.colonies(1, Size_1.Size.SMALL).any.startEffect.megacredits(2);
                        });
                    });
                }),
                description: 'Increase your energy production 1 step and gain 2 titanium.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.addResource(Resources_1.Resources.TITANIUM, 2);
        return undefined;
    }
}
exports.ColonyTradeHub = ColonyTradeHub;
//# sourceMappingURL=ColonyTradeHub.js.map